export const SET_PATHSTOPS = "SET_PATHSTOPS";
export const RESET_PATHSTOPS = "RESET_PATHSTOPS";
interface ActionTypes {
  SET_PATHSTOPS: any[];
  RESET_PATHSTOPS: undefined;
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload?: any;
}
export interface EmptyMessageAction {
  type: keyof ActionTypes;
}

export function setPathStops(pathStops: any[]): PathStopActionTypes {
  return {
    type: SET_PATHSTOPS,
    payload: pathStops,
  };
}

export function resetPathStops(): PathStopEmptyActionTypes {
  return {
    type: RESET_PATHSTOPS,
  };
}

export type PathStopActionTypes = MessageAction;
export type PathStopEmptyActionTypes = EmptyMessageAction;
